import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Start } from '../containers/Pages/Start';


const useStyles = makeStyles(() => ({
    root: {
        flexGrow: 1,
        minHeight: 216
    },
    headerMargin: {
        marginTop: 48
    }
}));

const Main = () => {
    const [page, setPage] = useState(null);
    const classes = useStyles();

    return (
        <div className={classes.root}>
        
            <div className={classes.headerMargin}>
                <Start page={page} setPage={setPage} />
            </div>
        </div>
    )
}

export default Main;
